import { MarkButton } from '../../../components/MarkControls';
import React from 'react';
import type { DripVersion } from '../../../types';
import * as styles from './detail.module.css';
type VersionSide = 'draft' | 'current';
type Props = {
    currentVersion: DripVersion | null;
    draftVersion: DripVersion | null;
    activeVersionNumber: number | null;
    onSelect: (side: VersionSide) => void;
};
const VersionSwitch: React.FC<Props> = ({
    currentVersion,
    draftVersion,
    activeVersionNumber,
    onSelect
}) => {
    const hasBoth = currentVersion != null && draftVersion != null;
    const isDraftActive =
        draftVersion != null && activeVersionNumber === draftVersion.version_number;
    const isCurrentActive =
        currentVersion != null && activeVersionNumber === currentVersion.version_number;
    return (
        <div role="group" aria-label="Version" className={styles.versionSwitch}>
            <span>Version</span>
            {draftVersion ? (
                <MarkButton
                    type="button"
                    compact
                    onClick={() => onSelect('draft')}
                    aria-pressed={isDraftActive}
                >
                    Draft v{draftVersion.version_number}
                </MarkButton>
            ) : (
                <MarkButton type="button" compact disabled>
                    No draft
                </MarkButton>
            )}
            {currentVersion ? (
                <MarkButton
                    type="button"
                    compact
                    onClick={() => onSelect('current')}
                    aria-pressed={isCurrentActive}
                    disabled={!hasBoth}
                >
                    Current v{currentVersion.version_number}
                </MarkButton>
            ) : (
                <MarkButton type="button" compact disabled>
                    No current version
                </MarkButton>
            )}
        </div>
    );
};
export default VersionSwitch;
